import { useMemo } from "react";
import cssIf from "../../../../scripts/helpers/class.add.if";
import prettyFloat from "../../../../scripts/helpers/pretty.float";
import twoDigitFormat from "../../../../scripts/helpers/two.digit.format";
import { CURRENCY_SYMBOL, DEAL_TYPES } from "../../../../settings/constants";
import useGlobal from "../../../../store";
import StatsItem from "./stats.item";

const HeaderStats = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { currency, history, dummy } = globalState;

  const countDeals = useMemo(() => {

    let counter = 0;

    history.forEach( day => {

      counter += day.orders.length;

    });

    return counter;

  }, [ history, currency, dummy ]);

  const countResult = useMemo(() => {

    let counter = 0;

    history.forEach( day => {

      day.orders.forEach( order => { counter += parseFloat( order.result ); });

    });

    return counter;

  }, [ history, currency, dummy ]);

  const countTodayResult = useMemo(() => {
    
    let counter = 0;
    if ( history.length === 0 ) { return counter; }

    const d = new Date();
    const today = `${ twoDigitFormat( d.getDate() ) }.${ twoDigitFormat( d.getMonth() + 1 ) }.${ d.getFullYear() }`

    const todayDeals = history.find( day => day.date === today );

    if ( todayDeals ) {

      todayDeals.orders.forEach( order => { counter += parseFloat( order.result ); });

    }

    return counter;

  }, [ history, currency, dummy ]);

  const [ countPlusDeals, countMinusDeals ] = useMemo(() => {

    let counterPlus = 0;
    let counterMinus = 0;

    history.forEach( day => {

      day.orders.forEach( deal => {

        if ( deal.result.toString().indexOf('-') === -1 ) { counterPlus += 1; }
        else { counterMinus += 1; }

      })

    });

    return [ counterPlus, counterMinus ];

  }, [ history, currency, dummy ]);

  const [ countLongDeals, countShortDeals ] = useMemo(() => {

    let longCounter = 0;
    let shortCounter = 0;

    history.forEach( day => {

      day.orders.length > 0 && day.orders.map( deal => {

        if ( deal.currency === currency ) {

          if ( deal.type === DEAL_TYPES.LONG ) { longCounter += 1; }
          else
          if ( deal.type === DEAL_TYPES.SHORT ) { shortCounter += 1; }
        
        }

      })

    });

    return [ longCounter, shortCounter ];

  }, [ history, currency, dummy ]);

  return (

    <div className = "stats">

      <StatsItem
        text = "Всего сделок:"
        number = { countDeals }
        color = "white"
      />
      
      <StatsItem

        text   = "В плюс:"
        number = { countPlusDeals }
        color  = "#57BB4F"

      />

      <StatsItem

        text   = "В минус:"
        number = { countMinusDeals }
        color  = "#E35162"

      />

      {/* <StatsItem

        text   = "В лонг:"
        number = { countLongDeals }
        color  = "#57BB4F"

      />

      <StatsItem

        text   = "В шорт:"
        number = { countShortDeals }
        color  = "#E35162"

      /> */}

      <StatsItem

        text   = "Сегодня:"
        number = {`${ cssIf( +countTodayResult !== 0 && countTodayResult.toString().indexOf('-') === -1, "+" ) }${ prettyFloat( countTodayResult ) }${ CURRENCY_SYMBOL?.[ currency ] || "" }`}
        color  = { countTodayResult.toString().indexOf('-') === -1 ? "#57BB4F" : "#E35162" }

      />
      
      <StatsItem

        text   = "За всё время:"
        number = {`${ cssIf( +countResult !== 0 && countResult.toString().indexOf('-') === -1, "+" ) }${ prettyFloat( countResult ) }${ CURRENCY_SYMBOL?.[ currency ] || "" }`}
        color  = { countResult.toString().indexOf('-') === -1 ? "#57BB4F" : "#E35162" }

      />

    </div>

  )

}

export default HeaderStats;